import * as React from 'react';

const ManageRoundIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 120 120" {...props}>
        <defs>
            <linearGradient
                id="manage-round-illustration_svg__linear-gradient"
                x1={35.73}
                y1={102.94}
                x2={84.58}
                y2={18.33}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#e09819" stopOpacity={0.2} />
                <stop offset={1} stopColor="#e09819" stopOpacity={0} />
            </linearGradient>
        </defs>
        <circle cx={59.84} cy={60.63} r={48.84} fill="#fcc870" />
        <circle
            cx={60.16}
            cy={60.63}
            r={48.84}
            fill="url(#manage-round-illustration_svg__linear-gradient)"
        />
        <path
            d="M94.6 94.93c.4-9.19 1.19-21.6.4-27.43-.2-1.4-2.86-8.14-3.74-9.13A41.31 41.31 0 0087 55c-1.23-1-2.39 2.27-1.09 3.87s2.07 2 2.23 2.65A49.4 49.4 0 0189.5 68c-.06 1-2.43-.64-3.08-1.38s-4.48-4.77-5.46-5.5a48.89 48.89 0 00-6.22-2.78c-1.22-.49-2.28 2.31-.85 3.29s4 2 4.47 2.61a48.25 48.25 0 013.37 4.32c.44.92 2.76 5.35 2.08 6s-3.91-3.33-5.07-3.79a22.1 22.1 0 00-6.25-.7 23.24 23.24 0 00-4.67 2.23c-1.07.65 6.67 1.83 7.6 2.2s4.45 3.15 4.27 3.33a25.45 25.45 0 01-3.19-2c-.48-.3-3-1.42-3.65-1.24a19.77 19.77 0 00-3.64 2.08c-1.09.76.05 2.83 2.09 2 4.21-1.8 7.23 4 7.38 5.19s-.07 7.14.7 10.28 3.83 6 3.79 7.54a8 8 0 01-.33 2.07 46.44 46.44 0 0011.76-8.82z"
            fill="#a23e24"
        />
        <path
            d="M69.55 75.34L86 79.19a2.39 2.39 0 002.88-1.79l8.32-35.68a2.39 2.39 0 00-1.79-2.88L79 35a2.39 2.39 0 00-2.88 1.79l-8.36 35.67a2.39 2.39 0 001.79 2.88z"
            fill="#f6f8fc"
        />
        <path
            fill="#d0ebee"
            d="M70.35 68.5l17.98 4.21 7.23-31.03-17.98-4.21-7.23 31.03z"
        />
        <path
            d="M94 95.48c-.52-5.94-13.94-20.84-14.49-21.58s-1.51-2.12-2.75-1.63-1.63 2.17-1.07 3.73 5.24 7.9 5.49 9-.91 5.84-.18 9 3.4 6.06 3.79 7.54a2.51 2.51 0 01-.22 1.22A49 49 0 0094 95.48z"
            fill="#be4d28"
        />
        <path
            d="M50.16 80.23a1.19 1.19 0 01-.84-2l28.52-28.54a1.19 1.19 0 012 .85v4.43L90 44.77a1.19 1.19 0 111.68 1.68L79.44 58.7a1.19 1.19 0 01-2-.85v-4.43L51 79.88a1.18 1.18 0 01-.84.35z"
            fill="#f16932"
        />
        <path
            d="M89.76 52.92a1.19 1.19 0 01-1.16-1.45l1.09-4.69L85 47.86a1.19 1.19 0 01-.54-2.31l8.39-1.94L90.91 52a1.19 1.19 0 01-1.15.92z"
            fill="#f16932"
        />
        <path
            d="M11.9 70.36a72.23 72.23 0 01-.9-8.27l22.15-3.41c-1 21.25 28.47 13.06 41 38.08"
            fill="#a23e24"
        />
        <path
            d="M12 70.34C19.48 105 55.72 115.82 77.51 106c-7.27-28.71-31.4-26.9-40.68-36.48-6.83 3.06-14.19 4.07-24.83.82z"
            fill="#00abae"
        />
        <path
            d="M54.68 13.29s6.46 1.43 5.86 16.45c-.4 10-1.26 21.69-2.34 22a9 9 0 01-3.16-.2s-1 9.2-5.7 10.65-12.76-3.37-12.76-3.37-9.07.24-11.31 2.6-12 3.53-14.24.71c-.31-9 2.15-23.52 2.15-23.52l23.91-23z"
            fill="#a23e24"
        />
        <path
            d="M38.88 37.31s-1.6 8.57 1 8.87C50.75 47.43 55 51.51 55 51.51s-.79 9-5.7 10.65c-3.58 1.22-10.48-1.74-12.76-3.37-2.09-1.49-5.16-5.23-5.2-8.86s3.9-11.61 5-12.8 2.54.18 2.54.18z"
            fill="#882d1c"
        />
        <path
            d="M46.84 4.37s-4.32-2.19-8.28-1-6.9 6.06-6.9 6.06S28 7 22.69 11.67s-9.51 26.9-9.51 26.9c7 4.25 14.73-1.34 14.73-1.34s-1.45-7.68 4.76-8.16 3.65 8.06 3.65 8.06 2.29 1 3.6-.18 4.18-6.65 5.72-11.65 1.2-11.07 3.78-10.3c8.21 2.34 11.77-4 7.14-8.88a7.76 7.76 0 00-9.72-1.75z"
            fill="#363a43"
        />
    </svg>
);

ManageRoundIllustrationSvg.displayName = 'ManageRoundIllustrationSvg';
export default ManageRoundIllustrationSvg;
